module.exports = __webpack_public_path__ + "img/eye-open.fa2e8fd8.svg";